import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { removeLineBreaks, trimEmptyLines } from 'Angular/utils/text-utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../modal-base/components/modal-base.component";
import * as i3 from "../modal-base/components/simple-modal-footer.component";
import * as i4 from "../modal-base/components/simple-modal-header.component";
import * as i5 from "Angular/features/components/modals/text-edit/text-edit.component";
function TextEditModalComponent_ycn_text_edit_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-text-edit", 7);
    i0.ɵɵlistener("textChanged", function TextEditModalComponent_ycn_text_edit_5_Template_ycn_text_edit_textChanged_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateText($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disableLineBreaks", ctx_r1.disableLineBreaks)("extraFormats", ctx_r1.extraFormats)("hideFormats", ctx_r1.hideFormats)("text", ctx_r1.text);
} }
/**
 *
 * Text Edit Modal Component
 *
 * Allows text edition with a WYSIWYG editor. Text is saved as HTML.
 *
 *
 * Input Properties:
 *
 *  title: A string for the modal header.
 *  text: HTML string that will be edited.
 *  extraFormats: A list of quill js toolbar editor formats
 *
 *
 * Output Properties:
 *
 *  textSaved: EventEmitter that emits when saving the edited text (as HTML string).
 *
 */
export class TextEditModalComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.extraFormats = [];
        this.hideFormats = false;
        this.characterLimit = null;
        this.disableLineBreaks = false;
        this.textSaved = new EventEmitter();
        this.modalOpen = false;
        this.domParser = new DOMParser();
        this.errorMessage = '';
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
    }
    onSubmit() {
        this.modalOpen = false;
        if (this.newText !== this.text)
            this.textSaved.emit(this.newText);
    }
    updateText(newText) {
        let newTextHtml;
        if (this.disableLineBreaks) {
            this.newText = removeLineBreaks(trimEmptyLines(newText));
            newTextHtml = this.domParser.parseFromString(this.newText, 'text/html');
            this.newText = Array.from(newTextHtml.querySelectorAll('p')).reduce((acc, p) => {
                return `${acc}${p.innerHTML}`;
            }, '');
        }
        else {
            this.newText = newText;
            newTextHtml = this.domParser.parseFromString(this.newText, 'text/html');
        }
        const characterCount = newTextHtml.body.textContent?.length || 0;
        if (this.characterLimit) {
            if (this.characterLimit && characterCount > this.characterLimit) {
                this.errorMessage = `Exceeded ${this.characterLimit} character limit.`;
            }
            else {
                this.errorMessage = '';
            }
            this.changeDetector.detectChanges();
        }
    }
}
TextEditModalComponent.ɵfac = function TextEditModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TextEditModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
TextEditModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextEditModalComponent, selectors: [["ycn-text-edit-modal"]], inputs: { title: "title", text: "text", extraFormats: "extraFormats", hideFormats: "hideFormats", characterLimit: "characterLimit", disableLineBreaks: "disableLineBreaks" }, outputs: { textSaved: "textSaved" }, standalone: false, decls: 7, vars: 8, consts: [[3, "closeModalHandler", "open", "requiresAction"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "modal-message"], [3, "disableLineBreaks", "extraFormats", "hideFormats", "text", "textChanged", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "disableSubmission", "errorText", "submitButtonText"], [3, "textChanged", "disableLineBreaks", "extraFormats", "hideFormats", "text"]], template: function TextEditModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function TextEditModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function TextEditModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵtemplate(5, TextEditModalComponent_ycn_text_edit_5_Template, 1, 4, "ycn-text-edit", 5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "ycn-simple-modal-footer", 6);
        i0.ɵɵlistener("cancelHandler", function TextEditModalComponent_Template_ycn_simple_modal_footer_cancelHandler_6_listener() { return ctx.closeModal(); })("submitHandler", function TextEditModalComponent_Template_ycn_simple_modal_footer_submitHandler_6_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen)("requiresAction", true);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.title);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("cancelButtonText", "Cancel")("disableSubmission", !!ctx.errorMessage)("errorText", ctx.errorMessage)("submitButtonText", "Save");
    } }, dependencies: [i1.NgIf, i2.ModalBaseComponent, i3.SimpleModalFooterComponent, i4.SimpleModalHeaderComponent, i5.TextEditComponent], encapsulation: 2 });
